<template>
  <div class="sac-filter-search-option">
    <SACSearch
      :search="search"
      :height="40"
      @input="(value) => changeSearch(value)"
    />
    <div class="filter-options-container">
      <div
        v-for="option in options"
        :key="option.value"
      >
        <button
          :class="[
            'filter-option',
            item.activeOption.value === option.value ? 'active' : '',
          ]"
          @click="select(option, item.key)"
        >
          <div class="text-ellipsis">
            {{ option.label }}
          </div>
          <img
            v-if="item.activeOption.value === option.value"
            src="@shared/assets/img/general/check-white.png"
            class="img-size_12"
          >
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import SACSearch from '@shared/components/sac/SACSearch.vue';

export default {
  name: 'FilterSearchOption',
  components: {
    SACSearch,
  },
  props: {
    item: Object,
    select: Function,
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    options() {
      if (this.search) {
        return this.item.options.filter((option) => {
          const text = this.search.toLowerCase();
          const {
            label,
          } = option;
          return !!label.toLowerCase().match(text);
        });
      }
      return this.item.options;
    },
  },
  methods: {
    changeSearch(search) {
      this.search = search;
    },
  },
};
</script>

<style lang="scss">

.sac-filter-search-option {
  display: grid;
  gap: 23px;

  .filter-options-container {
    display: grid;
    gap: 8px;
    max-height: 400px;
    overflow: auto;
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;

    /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }

    .filter-option {
      height: 40px;
      display: grid;
      grid-auto-flow: column;
      justify-content: space-between;
      align-items: center;
      background-color: $N5;
      width: 100%;
      font-size: 15px;
      font-weight: bold;
      color: $NAVY100;
      border-radius: 8px;
      padding: 0 17px;

      &.active {
        background-color: $NBLUE110;
        color: $WHITE;
      }

      .img-size_12 {
        height: 12px;
        width: auto;
      }
    }
  }
}
</style>
